export default __webpack_public_path__ + "static/media/Abyssal Demon Ring of Wisdom.d639c069.jpg";